import { z } from "zod";

/**
 * What the Decisions API said about each second of a recording.
 *
 * Raw scores only. The threshold, the speech rule and the grouping are applied
 * when cuts are planned, so changing any of them — or the user switching their
 * own voice back on — never needs the recording judged again.
 */
const probability = z.number().min(0).max(1).nullable();

export const frameJudgementSchema = z.object({
  version: z.literal(1),
  model: z.string(),
  seconds: z.array(z.object({ at: z.number().int().nonnegative(), waiting: probability, still: probability })),
});

export type FrameJudgement = z.infer<typeof frameJudgementSchema>;
export type FrameScore = FrameJudgement["seconds"][number];

/** The saved judgement, or null for anything that is not one — an older shape is no scores, not a crash. */
export function readFrameJudgement(data: unknown): FrameJudgement | null {
  const parsed = frameJudgementSchema.safeParse(data);
  return parsed.success ? parsed.data : null;
}
